import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  drawerContainer: {
    width: "250px",
    paddingTop: "12px",
  },
  appInfoContainer: {
    display: "flex",
    flexDirection: "row",
    paddingX: "36px",
    alignItems: "center",
    justifyContent: "space-evenly",
    flex: 1,
    width: "100%",
  },
  appNameText: {
    fontWeight: 600,
    fontSize: 22,
    color: colorsConstants.primary,
  },
  drawerAppIcon: {
    width: "64px",
    height: "64px",
  },
  listItemIcon: {
    marginLeft: "12px",
    color: colorsConstants.drawerListItemIcon,
  },
  listItemIconSelected: {
    marginLeft: "12px",
    color: colorsConstants.drawerListItemIconSelected,
  },
  ListItemButtonContainerSelected: {
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    marginX: "36px",
    borderRadius: "10px",
  },
  ListItemButtonContainer: {
    backgroundColor: colorsConstants.drawerListItemContainer,
    marginX: "36px",
    borderRadius: "10px",
  },
  ListItemContainer: { marginTop: "4px" },
  menuButton: { position: "absolute", left: "16px", top: "16px" },
  menuIcon: {
    fontSize: "32px",
    color: colorsConstants.primary,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
